import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ProgramsSection } from '../components/ProgramsSection';
import { CTASection } from '../components/CTASection';
import { motion } from 'framer-motion';
export function ProgramsPage() {
  return <div className="bg-black min-h-screen" data-id="element-509">
      <Navigation data-id="element-510" />

      {/* Page Header */}
      <div className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-511">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-512">
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-513">
            Our <span className="text-[#00D4FF]" data-id="element-514">Programs</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl leading-relaxed" data-id="element-515">
            From toddlers to adults, we have a martial arts curriculum designed
            to help you reach your full potential. Discover the perfect class
            for your age and skill level.
          </p>
        </motion.div>
      </div>

      {/* Main Content */}
      <ProgramsSection data-id="element-516" />

      {/* Additional Program Details */}
      <section className="py-20 bg-[#111]" data-id="element-517">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-518">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-519">
            <div data-id="element-520">
              <h2 className="text-3xl font-bold text-white mb-6" data-id="element-521">
                Why Choose Our Curriculum?
              </h2>
              <div className="space-y-6 text-gray-300" data-id="element-522">
                <p data-id="element-523">
                  Our curriculum is built on decades of experience, blending
                  traditional martial arts values with modern teaching
                  methodologies. We don't just teach you how to kick and punch;
                  we teach you how to succeed in life.
                </p>
                <p data-id="element-524">
                  Each program is structured with clear goals and progression
                  paths, ensuring that every student experiences a sense of
                  achievement as they advance through the ranks.
                </p>
                <ul className="space-y-3 mt-6" data-id="element-525">
                  {['Certified Instructors', 'Age-Appropriate Classes', 'Safe Training Environment', 'Personalized Attention'].map(item => <li key={item} className="flex items-center gap-3" data-id="element-526">
                      <div className="w-2 h-2 bg-[#00D4FF] rounded-full" data-id="element-527" />
                      <span className="text-white font-medium" data-id="element-528">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
            <div className="relative h-[400px] rounded-2xl overflow-hidden" data-id="element-529">
              <img src="https://images.unsplash.com/photo-1599058945522-28d584b6f0ff?q=80&w=2069&auto=format&fit=crop" alt="Instructor teaching students" className="w-full h-full object-cover" data-id="element-530" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-531" />
            </div>
          </div>
        </div>
      </section>

      <CTASection data-id="element-532" />
      <Footer data-id="element-533" />
    </div>;
}